import { connect } from 'react-redux';

import TopNavComponent from './TopNavComponent';

import { setDrawerOpen } from '../Main/actions';
import { showRenderPropsModal } from '../Modal/actions';
import { toggleCUNotifications } from '../Notification/actions';

import * as commonSelectors from '../Shared/selectors';
import * as selectors from './selectors';

const mapStateToProps = (state) => ({
  currentUser: commonSelectors.getCurrentUser(state),
  isDrawerOpen: commonSelectors.getIsDrawerOpen(state),
  isMobileScreen: commonSelectors.getIsMobileScreen(state),
  title: selectors.getTitle(state),
  hasNewMessages: selectors.getHasNewMessages(state),
  hasNewNotifications: selectors.getHasNewNotifications(state),
});

const mapDispatchToProps = (dispatch) => ({
  showRenderPropsModal: (modalProps) =>
    showRenderPropsModal(dispatch, modalProps),
  toggleCUNotifications: () => toggleCUNotifications(dispatch),
  setDrawerOpen: (isDrawerOpen) => setDrawerOpen(dispatch, isDrawerOpen),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNavComponent);
